export default __webpack_public_path__ + "static/media/0x8505b9d2254a7ae468c0e9dd10ccea3a837aef5c.adaa375a.png";